import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1SerievideoVideoidLangsQueryOptions,
  useDeleteApiV1SerievideoVideoidLangsId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um Idioma do Vídeo.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/serievideo/{videoId}/langs/{id}`
 * e invalida o cache da listagem após a exclusão bem-sucedida.
 *
 * @param videoId - ID do vídeo
 *
 * @example
 * ```tsx
 * const deleteSerieVideoLang = useDeleteSerieVideoLang(videoId);
 * deleteSerieVideoLang.mutate({ videoId, id: 12 });
 * ```
 */
export function useDeleteSerieVideoLang(videoId: number) {
  const queryClient = useQueryClient();

  return useDeleteApiV1SerievideoVideoidLangsId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1SerievideoVideoidLangsQueryOptions(videoId));
      },
    },
  });
}
